import { Autocomplete, TextField } from "@mui/material";
import { upiHandles } from "../data";
import { memo, useState } from "react";

const InputUpi = ({
    onChange = () => { },
    onBlur = () => { },
    open,
    value = '',
    name = "",
    error,
}) => {
    const [focus, setFocus] = useState({ invoiceUpi: "", posUpi: "" });
    const handleInputChange = (event, inputValue, type) => {
        onChange({ target: { value: inputValue } });
    };

    const getSuggestions = (UpiState) => {
        if (!value?.includes("@")) {
            return [];
        }
        const searchTerm = value.slice(
            value.indexOf("@") + 1
        );
        return upiHandles
            .filter((handle) => handle?.includes(searchTerm))
            .map(
                (handle) =>
                    value?.slice(0, value.indexOf("@") + 1) + handle
            );
    };
    return <Autocomplete
        open={
            focus.invoiceUpi == true &&
            getSuggestions(value).length !== 0
        }
        size="small"
        name={name}
        options={getSuggestions(value)}
        value={value}
        onChange={(e, i) => handleInputChange(e, i)}
        disableClearable
        error={error}
        renderInput={(params) => (
            <TextField
                {...params}
                name={name}
                placeholder="Example@ybl"
                label="Our UPI ID"
                variant="outlined"
                fullWidth
                value={value}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                    onChange(e, "upi_id");
                    setFocus((prev) => ({
                        ...prev,
                        invoiceUpi: true,
                    }));
                }}
                onFocus={() => {
                    setFocus((prev) => ({
                        ...prev,
                        invoiceUpi: true,
                    }));
                }}
                onBlur={(e) => {
                    setFocus((prev) => ({
                        ...prev,
                        invoiceUpi: false,
                    }));
                    onBlur(e);
                }}
                sx={{
                    "& .MuiAutocomplete-popupIndicator": {
                        display: "none", // Hide the dropdown icon
                    },
                    ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                    {
                        fontSize: "14px",
                    },
                    label: {
                        fontSize: "14px",
                    },
                    ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                        fontSize: "14px",
                    },
                    ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                    {
                        color: "input.font",
                    },
                    ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        borderColor: "input.border",
                    },
                    ".css-14qz1ij-MuiListItemText-root": {
                        margin: "0px",
                    },
                    ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                    },
                }}
            />
        )}
    />
}

export default memo(InputUpi) 